<template>
    <div id="aqt_content">
      <div class="content_body">
        <div class="aqt_serve">
          <div class="line line1"></div>
          <p class="aqt_serve_title">阿启泰的服务</p>
          <p class="serve_describe">构建文化艺术大数据生态体系，提供一站式数字化解决方案与技术服务，始终坚持以客户为中心、以奋斗者为本，持续深耕技术创新，长期稳定为客户创造价值。</p>
          <img src="../../assets/img/serve1.png" class="serve_img"/>
        </div>
        <div class=" special_serve">
          <div class="special_serve_head">
            <img src="../../assets/img/serve2.png" class="serve_img1"/>
            <p class="pecial_serve_title">阿启泰特有的服务</p>
            <img src="../../assets/img/serve3.png" class="serve_img1"/>
          </div>
          <div class="special_serve_content">
            <div class="special_serve_left">
              <div class="line line3"></div>
              <p class="serve_left_title">市场定位</p>
              <p class="serve_left_content">依托专业市场调研与数据分析，精准定位产品方向，塑造差异化品牌形象与核心竞争力。
              </p>

            </div>
            <div  class="special_serve_right">
              <img src="../../assets/img/serve4.png" class="serve_img2"/>
            </div>
          </div>
          <div class="special_serve_content2">
            <div class="serve_content2_left">
              <img src="../../assets/img/index9.png" class="serve_img3"/>
            </div>
            <div class="serve_content2_right">
              <div class="line line3"></div>
              <p class="serve2_right_title">需求分析</p>
              <p class="serve2_right_content">深度对接客户需求，全面梳理业务场景，量身定制专属解决方案。</p>
            </div>
          </div>
          <div class="special_serve_content" style="margin-top: 350px!important;">
            <div class="special_serve_left">
              <div class="line line3"></div>
              <p class="serve_left_title">UI设计</p>
              <p class="serve_left_content">专业设计团队匠心打造，贴合品牌调性，定制个性化视觉呈现与流畅交互体验。
              </p>

            </div>
            <div  class="special_serve_right">
              <img src="../../assets/img/serve6.png" class="serve_img2"/>
            </div>
          </div>
          <div class="special_serve_content2">
            <div class="serve_content2_left">
              <img src="../../assets/img/serve7.png" class="serve_img3"/>
            </div>
            <div class="serve_content2_right">
              <div class="line line3"></div>
              <p class="serve2_right_title">产品研发</p>
              <p class="serve2_right_content">资深前后端技术团队，按需定制开发，保障产品稳定、高效、安全落地。</p>
            </div>
          </div>
          <div class="special_serve_content" style="margin-top: 450px!important;">
            <div class="special_serve_left">
              <div class="line line3"></div>
              <p class="serve_left_title">功能测试</p>
              <p class="serve_left_content">严格遵循需求标准，全面校验功能逻辑，排查优化产品问题，提升使用体验。
              </p>

            </div>
            <div  class="special_serve_right">
              <img src="../../assets/img/serve8.png" class="serve_img2"/>
            </div>
          </div>
          <div class="special_serve_content2">
            <div class="serve_content2_left">
              <img src="../../assets/img/serve9.png" class="serve_img3"/>
            </div>
            <div class="serve_content2_right">
              <div class="line line3"></div>
              <p class="serve2_right_title">项目交付</p>
              <p class="serve2_right_content">专属项目团队全程对接，规范验收、高效交付，确保项目平稳上线与落地运营。</p>
            </div>
          </div>
        </div>
        <div class="serve_bottom">
          <div class="serve_bottom_title">
            <div class="line line4"></div>
            <p class="bottom_title">服务行业</p>
          </div>
          <img src="../../assets/img/index10.png" class="serve_img4"/>
          <ul class="serve_industry">
            <li class="industry_item" v-for="(industry_item,index) in industryArr" :key="index+1">
              <img :src="industry_item.img" class="industry_img"/>
              <p class="industry_name">{{industry_item.name}}</p>
            </li>

          </ul>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
      data(){
        return {
          industryArr:[
            {
              img:require('../../assets/img/serve11.png'),
              name:'文化艺术行业'
            },
            {
              img:require('../../assets/img/serve13.png'),
              name:'游戏行业'
            },
            {
              img:require('../../assets/img/serve14.png'),
              name:'政府部门'
            },
            {
              img:require('../../assets/img/serve12.png'),
              name:'教育行业'
            },
            {
              img:require('../../assets/img/serve15.png'),
              name:'医疗行业'
            },
            {
              img:require('../../assets/img/serve16.png'),
              name:'全行业数字化服务'
            }

          ]
        }
      }
    }
</script>

<style   scoped lang="less">
  #aqt_content{
    background:url('../../assets/img/serve17.png') no-repeat;
    background-size: 100% 25%;
    background-position:bottom;
    padding-top:70px;
    overflow: hidden;
    .content_body{
      width:70%;
      height:auto;
      margin:0px auto;
      .line{
        width:10%;
        height:1px ;
      }
      .line1{
        background-color:#F5A623;
        margin:50px auto;
      }
      .line3{
        background-color:#3399ED;
        margin-top:20px;
      }
      .line4{
        background-color:#0070D2;
        margin-top:20px;
        margin:0 auto;
      }
      .serve_img2{
        width:80%;
        margin-left:30%;
        margin-top:10px;
      }
      .serve_img3{
        width:80%;
      }
      .aqt_serve{
        width:100%;
        height:auto;

        .aqt_serve_title{
          width:100%;
          font-size:18px;
          color:#F4FAFF;
          text-align:center;
          margin-top:20px;
          margin-bottom:40px;
        }
        .serve_describe{
          width:70%;
          height:80px;
          text-align:center;
          margin:0 auto;
          line-height:30px;
          font-size:14px;
          color:#D3DFFF;
          margin-bottom:50px;

        }
        .serve_img{
          width:50%;
          margin-left:25%;
        }
      }
      .special_serve{
        width:100%;
        height:auto;
        margin-top:80px;
        .special_serve_head{
          width:70%;
          height:auto;
          margin:0 auto;
          display:flex;
          flex-direction:row;
          padding-left:17%;
          box-sizing:border-box;
          .serve_img1{
            height:30px;
          }
          .pecial_serve_title{
            font-size:18px;
            color:#F4FAFF;
            line-height:40px;
            margin-left:10%;
            margin-right:10%;
          }
        }
        .special_serve_content{
          width:100%;
          height:auto;
          display:flex;
          flex-direction:row;
          margin-top:150px;
          .special_serve_left{
            width:50%;
            height:100%;
            .serve_left_title{
              font-size:18px;
              color:#F4FAFF;
              line-height:30px;
              margin-top:30px;
              margin-bottom:30px;
            }
            .serve_left_content{
              font-size:14px;
              color:#D3DFFF;
              line-height:20px;
            }
          }
          .special_serve_right{
            width:50%;
            height:100%;

          }
        }
        .special_serve_content2{
          width:100%;
          height:300px;
          margin-top:100px;
          display:flex;
          flex-direction:row;
          .serve_content2_left{
            width:50%;
            height:100%;
          }
          .serve_content2_right{
            width:50%;
            height:100%;
            padding-left:50px;
            box-sizing: border-box;
            .serve2_right_title{
              font-size:18px;
              color:#F4FAFF;
              line-height:30px;
              margin-top:30px;
              margin-bottom:30px;
            }
            .serve2_right_content{
              font-size:14px;
              color:#D3DFFF;
              line-height:20px;
            }
          }
        }
      }
      .serve_bottom{
        width:100%;
        height:100%;
        margin-top:200px;
        .serve_bottom_title{
          width:100%;
          height:auto;
          text-align:center;
          .bottom_title{
            margin-top:50px;
            font-size:18px;
            color:#F4FAFF;
            margin-bottom:80px;
          }
        }
        .serve_img4{
          width:100%;
        }
        .serve_industry{
          width:100%;
          height:150px;
          margin-bottom:100px;
          display:flex;
          flex-direction:row;
          flex-wrap: wrap;
          .industry_item{
            width:33%;
            height:50%;
            display:flex;
            flex-direction:row;
            margin-top:20px;
            .industry_img{
              height:100%;

            }
            .industry_name{
              margin-left:5%;
              margin-top:10%;
              font-size:12px;
              color:#D3DFFF;
            }
          }
        }
      }
    }

  }

</style>
